import { Avatar, Column, Label } from '@tempmee/react';
import DefaultProfileImage from '~/images/defaultProfileImage.png';

interface IProps {
  profileImage: string;
  size: '2xl' | 'xl';
  showAdminLabel: boolean;
}

export const OfficeAvatar = ({ profileImage, size, showAdminLabel }: IProps) => (
  <Column align="center">
    {/* Offices keep their branded default photo when no image is set (GOTU-4428 Q2). */}
    <Avatar src={profileImage || DefaultProfileImage} size={size} alt="profile image" />
    {showAdminLabel && (
      <div style={{ marginTop: -10, alignSelf: 'center', zIndex: 4 }}>
        <Label severity="brand" variant="filled">
          ADMIN
        </Label>
      </div>
    )}
  </Column>
);
